import React, { useState } from "react"
import { Mutation } from "react-apollo"
import { Header, Flex, Segment, Label, Divider, Progress } from "@jjordy/layout"
import gql from "graphql-tag"
import RegisterTenantForm from "./RegisterTenantForm"
import RegisterAdminForm from "./RegisterAdminForm"
import { RouteComponentProps } from "@reach/router"
import styled, { createGlobalStyle } from "../styled"
import Center from "../Elements/Center"
import Logo from "../Logo"
import SignupSuccess from "./SignupSuccess"

const BodyColor = createGlobalStyle`
  body {
    background-color: ${(props) => props.theme.colors.lightGrey} !important;
  }
`

const LoginContainer = styled(Segment)`
  width: 350px;
  @media (max-width: 768px) {
    width: 98%;
    margin: auto;
  }
`

const REGISTER_TENANT_MUTATION = gql`
  mutation RegisterTenant($input: RegisterTenantInput!) {
    registerTenant(input: $input) {
      tenant {
        id
        tenantName
        tenantDomain
      }
    }
  }
`

export interface SignupProps extends RouteComponentProps {
  onDone: () => void
}

export interface RegisterTenantData {
  data: {
    registerTenant: {
      tenant: {
        id: string
        tenantName: string
        tenantDomain: string
      }
    }
  }
  loading?: boolean
  error?: Error
  [key: string]: any
}

export interface RegisterTenantVariables {
  input: {
    tenantName: string
    tenantDomain: string
  }
}

type TenantState = string | null

class RegisterTenantMutation extends Mutation<RegisterTenantData, RegisterTenantVariables> {}

const Signup: React.SFC<SignupProps> = ({}) => {
  const [step, setStep] = useState(1)
  const [tenantId, setTenantId] = useState<TenantState>(null)
  return (
    <Flex align="center" justify="center" style={{ height: "60vh" }}>
      <BodyColor />
      <LoginContainer>
        <Center direction="column">
          <Logo />
        </Center>
        <Segment my={1} p={1} bg="success">
          <Flex align="flex-start" justify="space-between" rounded={false}>
            <div>
              <Header fg="grey" as="h6" m={0}>
                {step === 1 && "Create Organization"}
                {step === 2 && "Create Account"}
                {step === 3 && "Success"}
              </Header>
            </div>
            <Label bg="success">Step {step} of 3</Label>
          </Flex>
        </Segment>
        <Progress percent={(step / 3) * 100} />
        <Divider />
        {step === 1 && (
          <RegisterTenantMutation mutation={REGISTER_TENANT_MUTATION}>
            {(registerTenant, { loading }) => (
              <RegisterTenantForm
                onSubmit={(v) => {
                  registerTenant({
                    variables: {
                      input: v
                    }
                  }).then((d: any) => {
                    setTenantId(d.data.registerTenant.tenant.id)
                    setStep(2)
                  })
                }}
                loading={loading}
              />
            )}
          </RegisterTenantMutation>
        )}
        {step === 2 && tenantId && <RegisterAdminForm onDone={() => setStep(3)} tenantId={tenantId} />}
        {step === 3 && <SignupSuccess />}
      </LoginContainer>
    </Flex>
  )
}

export default Signup
